import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";

const GeneratPurchaseInfo = ({ invoice }) => {
  const inputRef = useRef(null);
  const { t, i18n } = useTranslation("translations");

  const daysRemaining=()=>{
    let today = moment()

    let paymentRequestedDate = moment(invoice.dueDateTime)
    let daysLeft = paymentRequestedDate.diff(today, 'days')
    if(daysLeft < 0){
      return 0;
    }else{
    return daysLeft
  }
}

  return (
    <div className="card border-0 shadow-sm mb-3 w-100">
      <div className="d-flex justify-content-between header border-bottom py-2 px-3">
        <label className="fw-bold mb-0" style={{fontSize:"16px", fontWeight:600}}>
          {t("invoice.generalPurchaseInfo")}
        </label>
      </div>
      <div className="px-3 py-3">
        <div className="row">
          <div className="col-12 col-md-6 mb-2">
            <label className="field-label" htmlFor="supplierInfo">{t("invoice.suppliersInfo")}</label>
            <input
              type="text"
              name="supplierInfo"
              id="supplierInfo"
              className="form-control form-control-sm"
              value={(invoice?.connectionTransactional?.name ?? "") + (invoice?.connectionTransactional?.tin ? "," + (invoice?.connectionTransactional?.tin ?? "") : "")}
              disabled
            />
          </div>
          <div className="col-12 col-md-6 mb-2">
            <label className="field-label" htmlFor="docNumber">
              {t("invoice.docNumber")}
            </label>
            <input
              type="text"
              name="docNumber"
              id="docNumber"
              className="form-control form-control-sm"
              value={invoice?.docNumber ?? ""}
              onChange={() => {}}
              disabled
            />
          </div>
          <div className="col-12 col-md-6 mb-2">
            <label className="field-label" htmlFor="invoiceDate">
              {t("invoice.invoiceDate")}
            </label>
            <input
              type="text"
              name="invoiceDate"
              id="invoiceDate"
              className="form-control form-control-sm"
              value={moment(invoice?.recordDateTime).format("DD/MM/YYYY") ?? ""}
              disabled
            />
          </div>
          <div className="col-12 col-md-6 mb-2">
            <label className="field-label" htmlFor="ammount">{t("home.amount")}</label>
            <input
              type="text"
              name="ammount"
              id="ammount"
              className="form-control form-control-sm"
              value={invoice?.amount ?? ""}
              disabled
            />
          </div>
          <div className="col-12 col-md-6 mb-2">
            <label className="field-label" htmlFor="daysRemaining">{t("invoice.daysRemain")}</label>
            <input
              type="text"
              name="daysRemaining"
              id="daysRemaining"
              className="form-control form-control-sm"
              value={invoice?.dueDateTime ? daysRemaining() : ""}
              disabled
            />
          </div>
          <div className="col-12 col-md-6 mb-2">
            <label className="field-label" htmlFor="cisStatus">{t("purchases.cisStatus")}</label>
            <input
              type="text"
              name="cisStatus"
              id="cisStatus"
              className="form-control form-control-sm"
              value={invoice?.myPurchaseStatus?.name ?? ""}
              disabled
            />
          </div>
          <div className="col-12 col-md-6 mb-2">
            <label className="field-label" htmlFor="fic">FIC</label>
            <input
              type="text"
              name="fic"
              id="fic"
              className="form-control form-control-sm"
              value={invoice?.purchaseInvoiceExtracted?.fic ?? ""}
              disabled
            />
          </div>
          <div className="col-12 col-md-6 mb-2">
            <label className="field-label" htmlFor="eicGeneral">EIC</label>
            <input
              type="text"
              name="eicGeneral"
              id="eicGeneral"
              className="form-control form-control-sm"
              value={invoice?.eic ?? ""}
              disabled
            />
          </div>
          <div className="col-12 col-md-6 mb-2">
            <label className="field-label" htmlFor="iicGeneral">{t("invoice.IIC")}</label>
            <input
              type="text"
              name="iicGeneral"
              id="iicGeneral"
              className="form-control form-control-sm"
              value={invoice?.purchaseInvoiceExtracted?.iic ?? ""}
              disabled
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GeneratPurchaseInfo;
